import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=517b0e6d&scoped=true"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b0e6d",
  null
  
)

export default component.exports